import styled from '@emotion/styled';

const SuggestedDestination = styled('div')({
  paddingTop: '1.6rem',
});

export default SuggestedDestination;
